<template>
    <svg
        width="61"
        height="73"
        viewBox="0 0 61 73"
        xmlns="http://www.w3.org/2000/svg"
    >
        <defs>
            <path
                d="m0.62,0.182l12.516,0l0,15.818l-12.516,0l0,-15.818z"
                id="a"
            />
            <path d="m0.825,0.139l9.86,0l0,15.66l-9.86,0l0,-15.66z" id="c" />
            <path d="m0,16l72.781,0l0,-15.861l-72.781,0l0,15.861z" id="e" />
            <path d="m0,0l60.73,0l0,72.295l-60.73,0l0,-72.295z" id="g" />
        </defs>
        <g>
            <rect
                fill="none"
                id="canvas_background"
                height="75"
                width="63"
                y="-1"
                x="-1"
            />
        </g>
        <g id="svg_1" fill-rule="evenodd" fill="none">
            <g id="svg_9">
                <path
                    id="svg_10"
                    d="m48.733,71.27l0,-26.767l11.245,-6.51l0.002,26.786l-11.247,6.493l0,-0.002zm-35.987,-33.522l35.237,6.848l0,26.674l-35.237,-20.344l0,-13.18l0,0.002zm-0.75,-36.725l0.001,26.769l-11.246,6.51l0,-26.784l11.245,-6.494l0,-0.001zm35.987,33.525l-35.236,-6.85l0,-26.673l35.236,20.345l0,13.18l0,-0.002zm0.308,9.342l-35.796,-6.957c-0.013,-0.005 -0.022,-0.017 -0.036,-0.02l-11.028,-2.137l11.007,-6.372l35.796,6.958c0.014,0.004 0.022,0.017 0.036,0.019l11.028,2.139l-11.007,6.37zm12.437,-6.55c0,-0.007 -0.004,-0.013 -0.004,-0.021c0,-0.013 0,-0.026 -0.004,-0.04c-0.003,-0.017 -0.009,-0.033 -0.014,-0.05a0.415,0.415 0 0 0 -0.02,-0.053c-0.004,-0.008 -0.004,-0.015 -0.008,-0.023c-0.003,-0.004 -0.007,-0.006 -0.009,-0.01c-0.009,-0.014 -0.02,-0.024 -0.03,-0.037a0.292,0.292 0 0 0 -0.043,-0.044c-0.009,-0.01 -0.017,-0.018 -0.026,-0.025c-0.012,-0.008 -0.027,-0.013 -0.04,-0.02a0.394,0.394 0 0 0 -0.055,-0.026c-0.014,-0.005 -0.026,-0.01 -0.04,-0.013l-0.01,-0.005l-11.692,-2.267l0,-13.553a0.375,0.375 0 0 0 -0.187,-0.325l-35.986,-20.778c-0.007,-0.004 -0.014,-0.003 -0.022,-0.007l-0.044,-0.02a0.76,0.76 0 0 0 -0.05,-0.012c-0.018,-0.003 -0.033,-0.006 -0.05,-0.007c-0.007,0 -0.014,-0.004 -0.022,-0.004c-0.008,0 -0.014,0.004 -0.022,0.004c-0.016,0 -0.032,0.004 -0.048,0.007a0.76,0.76 0 0 0 -0.05,0.013a0.607,0.607 0 0 0 -0.046,0.019c-0.007,0.004 -0.014,0.003 -0.02,0.007l-12,6.927a0.372,0.372 0 0 0 -0.186,0.323l0.001,27.652c0,0.008 0.004,0.015 0.004,0.023a0.574,0.574 0 0 0 0.004,0.039c0.003,0.018 0.01,0.033 0.015,0.05c0.006,0.019 0.011,0.037 0.02,0.054c0.003,0.007 0.003,0.015 0.007,0.022c0.002,0.004 0.006,0.005 0.008,0.008c0.01,0.015 0.021,0.026 0.032,0.04a0.386,0.386 0 0 0 0.05,0.049c0.014,0.012 0.027,0.024 0.042,0.033l0.026,0.013c0.02,0.01 0.04,0.016 0.06,0.023c0.012,0.004 0.023,0.012 0.036,0.014l11.691,2.267l0,13.555c0,0.134 0.071,0.258 0.188,0.324l35.987,20.779l0.002,0c0.005,0.004 0.012,0.003 0.017,0.005a0.376,0.376 0 0 0 0.166,0.044l0.004,0a0.37,0.37 0 0 0 0.166,-0.044c0.005,-0.002 0.012,-0.001 0.018,-0.004l0.002,-0.001l11.996,-6.926a0.378,0.378 0 0 0 0.188,-0.325l-0.002,-27.653l0,-0.001z"
                    fill="#000000"
                />
            </g>
        </g>
    </svg>
</template>

<script lang="ts">
import { Vue, Options } from "vue-class-component";

@Options({
    name: "IconZupit",
})
export default class IconZupit extends Vue {}
</script>
